import LegalPageLayout from "@/components/feature/LegalPageLayout";
import TermsSections from "./components/TermsSections";
import Seo from "@/components/feature/Seo";
import { seoMeta } from "@/lib/seo";

export default function Terms() {
  return (
    <>
      <Seo title={seoMeta.terms.title} description={seoMeta.terms.description} />
      <LegalPageLayout
        kicker="TERMS OF SERVICE"
        title="利用規約"
        meta="制定日:2026年8月1日"
      >
        <TermsSections />
      </LegalPageLayout>
    </>
  );
}